export default {
  SET_USERINFO({ commit }, data) {
    commit('SET_USERINFO', data);
  },

  SET_FROM({ commit }, data) {
    commit('SET_FROM', data);
  },

  SET_USERPHONE({ commit }, data) {
    commit('SET_USERPHONE', data);
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/store/actions.js